// Filtro de rango de fecha genérico — mismo patrón que ya usan `utils/trips.ts`
// y `utils/logbook.ts` (duplicado en los dos, no consolidado hasta ahora).
// FE-24 lo necesita para el dashboard sin acoplarse a ninguno de los dos
// dominios; no se tocan las copias existentes para no arriesgar código ya
// cerrado de otras épicas — consolidarlas en una es limpieza para otro día.
export type DateFilterId = 'today' | '7days' | 'month' | 'all';

export const DATE_FILTERS: { id: DateFilterId; label: string }[] = [
  { id: 'today', label: 'Hoy' },
  { id: '7days', label: 'Últimos 7 días' },
  { id: 'month', label: 'Este mes' },
  { id: 'all', label: 'Todo' },
];

export function rangoDeFiltro(filtro: DateFilterId): { from?: string; to?: string } {
  if (filtro === 'all') return {};
  const inicio = new Date();
  const fin = new Date();
  fin.setHours(23, 59, 59, 999);

  if (filtro === 'today') {
    inicio.setHours(0, 0, 0, 0);
  } else if (filtro === '7days') {
    inicio.setDate(inicio.getDate() - 6);
    inicio.setHours(0, 0, 0, 0);
  } else {
    inicio.setDate(1);
    inicio.setHours(0, 0, 0, 0);
    fin.setMonth(fin.getMonth() + 1, 0);
    fin.setHours(23, 59, 59, 999);
  }

  return { from: inicio.toISOString(), to: fin.toISOString() };
}
